import { render, staticRenderFns } from "./MenuInicio.vue?vue&type=template&id=869b41d0&scoped=true&"
import script from "./MenuInicio.vue?vue&type=script&lang=js&"
export * from "./MenuInicio.vue?vue&type=script&lang=js&"
import style0 from "./MenuInicio.vue?vue&type=style&index=0&id=869b41d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869b41d0",
  null
  
)

export default component.exports